var map = {
	"./audio-muted.svg": 2112,
	"./audio.svg": 4534,
	"./copy.svg": 5063,
	"./github.svg": 6045,
	"./language.svg": 5094,
	"./video-muted.svg": 7255,
	"./video.svg": 7889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;